import { render, staticRenderFns } from "./tipoTintas.vue?vue&type=template&id=7b19a2fa&"
import script from "./tipoTintas.vue?vue&type=script&lang=js&"
export * from "./tipoTintas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports